import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import FilterString from '../../FilterString';
import { array as arrayFormatter } from '../../../DataGrid/formatters';
import { fulfilment as fulfilmentApi } from '@afosto/fulfilment/api/Fulfilment';

const FulfilmentLocationRenderer = ({ name, operator, renderSettings, value }) => {
  const [fulfilmentLocations, setFulfilmentLocations] = useState([]);
  const valueRef = useRef(value);

  useEffect(() => {
    valueRef.current = value;
  });

  useEffect(() => {
    const initialValue = valueRef.current;

    const fetchFulfilmentLocations = async () => {
      try {
        const promises = initialValue.map(fulfilmentLocationId =>
          fulfilmentApi.getFulfilmentLocation(fulfilmentLocationId),
        );
        const results = await Promise.all(promises);

        const formattedFulfilmentLocations = results.reduce((acc, result) => {
          const fulfilmentLocation = result?.data;

          if (fulfilmentLocation) {
            return [
              ...acc,
              {
                ...fulfilmentLocation,
                label: fulfilmentLocation.name,
                value: fulfilmentLocation.id,
              },
            ];
          }

          return acc;
        }, []);

        setFulfilmentLocations(formattedFulfilmentLocations);
      } catch (err) {
        setFulfilmentLocations([]);
      }
    };

    if (initialValue && initialValue?.length > 0) {
      fetchFulfilmentLocations();
    }
  }, []);

  const getValue = () => {
    if (['in', 'not_in'].includes(operator)) {
      return (
        <>
          {arrayFormatter(fulfilmentLocations.map(fulfilmentLocation => fulfilmentLocation.label))}
        </>
      );
    }

    const [firstFulfilmentLocation] = fulfilmentLocations;
    return firstFulfilmentLocation?.label;
  };

  return (
    <FilterString
      name={name}
      operator={operator}
      renderSettings={renderSettings}
      value={getValue()}
    />
  );
};

FulfilmentLocationRenderer.propTypes = {
  name: PropTypes.string,
  operator: PropTypes.string,
  renderSettings: PropTypes.object,
  value: PropTypes.array,
};

FulfilmentLocationRenderer.defaultProps = {
  name: '',
  operator: '',
  renderSettings: {},
  value: [],
};

export default FulfilmentLocationRenderer;
